import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bfLogo from "../assets/bf_logo.png";
import "./LegalPages.css";

const DatenschutzPage = () => {
  const navigate = useNavigate();

  // "Smart" kalbos parinkimas
  const [lang, setLang] = useState(() => {
    const browserLang = navigator.language || navigator.userLanguage || "de";
    return browserLang.startsWith("en") ? "en" : "de";
  });

  const t = {
    de: {
      title: "Datenschutzerklärung",
      back: "Zurück",
      binding: "Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Nachfolgend informieren wir Sie über die Erhebung und Verarbeitung Ihrer Daten bei Nutzung der BuildForce AL App.",
      sections: [
        { 
          h: "1. Verantwortliche Stelle", 
          p: "Verantwortlich für die Datenverarbeitung ist BuildForce AL (registriert in Zypern). Bei Fragen zum Datenschutz kontaktieren Sie uns bitte direkt über die App oder per E-Mail." 
        },
        { 
          h: "2. Erhebung von Standortdaten (GPS)", 
          p: "Zur Erbringung der Dienstleistung (Arbeitszeiterfassung und Einsatzplanung) erfasst die App Standortdaten der Mitarbeiter. Diese Erfassung erfolgt ausschließlich während der aktiven Arbeitszeit (Check-In bis Check-Out) in definierten Intervallen (z.B. alle 10 Minuten)." 
        },
        { 
          h: "3. Speicherung und Sicherheit", 
          p: "Alle Daten werden auf sicheren Servern (Google Cloud / Firebase) innerhalb der EU oder in Ländern mit angemessenem Datenschutzniveau gespeichert. Wir setzen moderne Verschlüsselungstechnologien ein, um Ihre Daten vor unbefugtem Zugriff zu schützen." 
        },
        { 
          h: "4. Weitergabe an Dritte", 
          p: "Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, dies ist zur Vertragserfüllung notwendig oder gesetzlich vorgeschrieben. Ihre Daten werden keinesfalls zu Werbezwecken verkauft." 
        },
        { 
          h: "5. Ihre Rechte", 
          p: "Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen." 
        }
      ]
    },
    en: {
      title: "Privacy Policy",
      back: "Back",
      binding: "We take the protection of your personal data very seriously. Below we inform you about the collection and processing of your data when using the BuildForce AL App.",
      sections: [
        { 
          h: "1. Responsible Entity", 
          p: "The party responsible for data processing is BuildForce AL (registered in Cyprus). If you have any questions about data protection, please contact us directly via the app or by email." 
        },
        { 
          h: "2. Collection of Location Data (GPS)", 
          p: "To provide the service (time tracking and workforce scheduling), the app collects employee location data. This collection occurs exclusively during active working hours (Check-In to Check-Out) in defined intervals (e.g., every 10 minutes)." 
        },
        { 
          h: "3. Storage and Security", 
          p: "All data is stored on secure servers (Google Cloud / Firebase) within the EU or in countries with an adequate level of data protection. We use modern encryption technologies to protect your data from unauthorized access." 
        },
        { 
          h: "4. Sharing with Third Parties", 
          p: "Your data will not be shared with third parties unless necessary for contract fulfillment or required by law. Your data will never be sold for advertising purposes." 
        },
        { 
          h: "5. Your Rights", 
          p: "You have the right to free information about your stored personal data at any time, as well as a right to correction, blocking, or deletion of this data, provided there are no legal retention obligations." 
        }
      ]
    }
  };

  return (
    <div className="legal-body">
      <nav className="legal-navbar">
        <div className="nav-container">
          <div className="logo-container" onClick={() => navigate("/")} style={{cursor: 'pointer'}}>
            <img src={bfLogo} alt="BF" className="bf-nav-logo" />
            <div className="logo-text">BUILDFORCE <span>AL</span></div>
          </div>
          <div className="nav-right">
            <div className="lang-switcher">
              <span onClick={() => setLang("en")} className={lang === "en" ? "active-lang" : ""}>EN</span>
              <span className="lang-divider">|</span>
              <span onClick={() => setLang("de")} className={lang === "de" ? "active-lang" : ""}>DE</span>
            </div>
            <button className="back-home-btn" onClick={() => navigate("/")}>{t[lang].back}</button>
          </div>
        </div>
      </nav>
      <div className="legal-content">
        <h1>{t[lang].title}</h1>
        <p className="binding-notice">{t[lang].binding}</p>
        {t[lang].sections.map((s, i) => (
          <div key={i} className="legal-section">
            <h2>{s.h}</h2>
            <p>{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DatenschutzPage;